const Visit = () => {
    return(
        <>
            <div className="container">
                <h4 className="white-text min-width">
                    <blocks>
                        Directions to NTU Physics Department
                    </blocks>
                </h4>
                <br />
                <div className="">
                    <a href="https://www.google.com/maps/place/%E5%8F%B0%E5%A4%A7%E7%89%A9%E7%90%86%E7%B3%BB/@25.0218252,121.5362383,19z/data=!4m9!1m2!2m1!1z5Y-w5aSnIOeJqeeQhuezuw!3m5!1s0x3442a98804669c89:0xe3cec3b7ff0bff80!8m2!3d25.0219905!4d121.536574!15sChDlj7DlpKcg54mp55CG57O7IgOIAQGSARJyZXNlYXJjaF9pbnN0aXR1dGU?hl=zh-TW" target="_blank" rel="noopener noreferrer">
                        <img className="map" src="https://web.phys.ntu.edu.tw/string/pic/map_test.png" alt="" />
                    </a>
                </div>

                <h5 className="white-text">• Site Location</h5>
                <p className="white-text">
                    The Physics department is at the intersection of Section 2, Xinhai Road (辛亥路二段) and Section 3, 
                    XinSheng South Road (新生南路三段), 
                    a pencil-like building right next to NTU sports center.
                </p>
                <p className="white-text">
                    <b>All the faculty offices are on the 8th floor</b>.
                </p>
            </div>
            <br />
        </>
    )
}

export default Visit;